// Initialize Foundation
jQuery(document).foundation();


// Run when DOM is ready
(function($) {

var $grid = $('.grid').masonry({
	itemSelector: '.grid-item',
	columnWidth: '.grid-sizer',
	percentPosition: true
});
$grid.imagesLoaded().progress( function() {
  	$grid.masonry('layout');
});


var $filtergrid = $('.filter-grid').isotope({
	itemSelector: '.grid-item',
	layoutMode: 'fitRows'
});
// filter items on button click
$('.filter-list').on( 'click', 'a', function() {
	var filterValue = $(this).attr('data-filter');
	$filtergrid.isotope({ filter: filterValue });
});
// swap is-active class on buttons
$('.filter-list').each( function( i, buttonGroup ) {
	var $buttonGroup = $( buttonGroup );
	$buttonGroup.on( 'click', 'a', function() {
		$buttonGroup.find('.is-active').removeClass('is-active');
		$( this ).addClass('is-active');
	});
});


var $grid = $('.pack-grid').packery({
	itemSelector: '.grid-item',
	columnWidth: '.grid-sizer',
	percentPosition: true
});
// layout Packery after each image loads
$grid.imagesLoaded().progress( function() {
  	$grid.packery();
});


})(jQuery);
